import Mutations from '../../odata/mutations';

export default { ...new Mutations('canEndInspection'), ...new Mutations('canEndInspections') };
